import { ExternalConnectAccountContext } from "@shared/features/configuration/ExternalConnectAccount.context.ts";
import { PropsWithChildren, useMemo, useState } from "react";
import useQuery from "utils/hooks/useQuery.ts";
import { sharedLib } from "@shared/services/shared.service.ts";
import { skipToken } from "@reduxjs/toolkit/query";
import { ConnectExternalAccountStep } from "@shared/features/configuration/types.ts";
import LoadingSpinnerOverlay from "common/Overlays/LoadingSpinnerOverlay.tsx";

export const ExternalConnectAccountProvider = ({
  children,
}: PropsWithChildren) => {
  const query = useQuery();
  const token = query.get("token") ?? undefined;
  const exchange = query.get("exchange") ?? undefined;
  const { data, isLoading, isError, error } =
    sharedLib.sharedApi.configuration.useGetAccountInviteQuery(
      token ? { authToken: token } : skipToken
    );
  const [step, setStep] = useState(
    exchange
      ? ConnectExternalAccountStep.CONNECT_EXCHANGE
      : ConnectExternalAccountStep.SELECT_EXCHANGE
  );

  const getContent = () => {
    return (
      <LoadingSpinnerOverlay
        isLoading={isLoading}
        hideContentWhileLoading={true}
        spinnerSize="large"
        spinnerMarginTop={150}
      >
        {children}
      </LoadingSpinnerOverlay>
    );
  };

  const errorMessage = error?.data?.message;
  const value = useMemo(() => {
    return {
      isExternalConnectAccount: true,
      accountName: data?.name,
      token,
      exchange,
      step,
      setStep,
      isError,
      errorMessage,
    };
  }, [data, token, step, exchange, errorMessage, isError]);

  return (
    <ExternalConnectAccountContext.Provider value={value}>
      {getContent()}
    </ExternalConnectAccountContext.Provider>
  );
};

export default ExternalConnectAccountProvider;
